var $7f23a91af36dfe30$exports = {};
$7f23a91af36dfe30$exports = {
    "clear": `Kirkas`,
    "invalid": `(ep\xe4kelpo)`,
    "loading": `Ladataan...`,
    "noResults": `Ei tuloksia`,
    "valid": `(kelvollinen)`
};


export {$7f23a91af36dfe30$exports as default};
//# sourceMappingURL=fi-FI.mjs.map
